import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vShow as _vShow, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e046c9c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mt-5" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mb-4 text-center" }, "リレーの設定", -1))
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "card p-3" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "hostSelect",
  class: "form-label"
}, "接続先ホスト", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "ホストを選択してください", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "col-12 mb-3" }
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "col-12 mb-3" }
const _hoisted_19 = { class: "card" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, "接続")
], -1))
const _hoisted_21 = {
  key: 0,
  class: "card-body"
}
const _hoisted_22 = {
  key: 0,
  class: "list-group"
}
const _hoisted_23 = {
  key: 0,
  class: "badge bg-success ms-2"
}
const _hoisted_24 = {
  key: 1,
  class: "badge bg-danger ms-2"
}
const _hoisted_25 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_26 = { class: "card-body" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-12 mb-3" }
const _hoisted_29 = { class: "card" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mb-0" }, "デバイス")
], -1))
const _hoisted_31 = { class: "card-body" }
const _hoisted_32 = { class: "mb-3" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "デバイスを選択してください", -1))
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "mb-3" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "操作")
], -1))
const _hoisted_38 = { class: "mb-3" }
const _hoisted_39 = {
  key: 0,
  class: "offset-1 mt-3"
}
const _hoisted_40 = { class: "me-2" }
const _hoisted_41 = { class: "form-check form-switch" }
const _hoisted_42 = ["id", "onUpdate:modelValue", "onChange", "disabled"]
const _hoisted_43 = ["for"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "設定")
], -1))
const _hoisted_45 = { class: "mb-3" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "メール設定", -1))
const _hoisted_47 = { class: "mb-3" }
const _hoisted_48 = { class: "mb-2" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "email-label",
  for: "tags"
}, "To :", -1))
const _hoisted_50 = {
  name: "tags",
  ref: "to",
  placeholder: "メールアドレスを入力"
}
const _hoisted_51 = { class: "mb-2" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "email-label",
  for: "tags"
}, "Cc :", -1))
const _hoisted_53 = {
  name: "tags",
  ref: "cc",
  placeholder: "メールアドレスを入力"
}
const _hoisted_54 = { class: "mb-2" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "email-label",
  for: "tags"
}, "Bcc :", -1))
const _hoisted_56 = {
  name: "tags",
  ref: "bcc",
  placeholder: "メールアドレスを入力"
}
const _hoisted_57 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "email-label" }, "Subject :", -1))
const _hoisted_59 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "email-label" }, "Body :", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "Twilio設定", -1))
const _hoisted_62 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_63 = { class: "mb-2" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "電話番号:", -1))
const _hoisted_65 = ["onUpdate:modelValue"]
const _hoisted_66 = ["onUpdate:modelValue"]
const _hoisted_67 = ["onUpdate:modelValue"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "mb-2" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "本文:", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "IoTHub設定", -1))
const _hoisted_72 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_73 = { class: "mb-2" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "センサー1名:", -1))
const _hoisted_75 = { class: "mb-2" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "センサー2名:", -1))
const _hoisted_77 = { class: "mb-3" }
const _hoisted_78 = ["disabled"]
const _hoisted_79 = { class: "col-12 mb-3" }
const _hoisted_80 = {
  key: 0,
  class: "card"
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, "受信メッセージ")
], -1))
const _hoisted_82 = { class: "card-body" }
const _hoisted_83 = { class: "table-responsive" }
const _hoisted_84 = { class: "table table-sm" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "トピック"),
    /*#__PURE__*/_createElementVNode("th", null, "メッセージ"),
    /*#__PURE__*/_createElementVNode("th", null, "受信時刻")
  ])
], -1))
const _hoisted_86 = { key: 0 }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  class: "text-center"
}, "メッセージはありません", -1))
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = {
  key: 0,
  class: "col-12"
}
const _hoisted_90 = {
  key: 0,
  class: "card"
}
const _hoisted_91 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, "ログ", -1))
const _hoisted_93 = { class: "btn-group" }
const _hoisted_94 = { class: "card-body" }
const _hoisted_95 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "全てのトピック", -1))
const _hoisted_97 = ["value"]
const _hoisted_98 = { class: "table-responsive" }
const _hoisted_99 = { class: "table table-sm" }
const _hoisted_100 = { key: 0 }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Time", -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Topic", -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Command", -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Body", -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "DateTime", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Client ID", -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "User", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "QoS", -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Node", -1))
const _hoisted_110 = [
  _hoisted_101,
  _hoisted_102,
  _hoisted_103,
  _hoisted_104,
  _hoisted_105,
  _hoisted_106,
  _hoisted_107,
  _hoisted_108,
  _hoisted_109
]
const _hoisted_111 = { key: 1 }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Time", -1))
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Event", -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Client ID", -1))
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Username", -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Mountpoint", -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Peername", -1))
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Protocol", -1))
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Version", -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Keepalive", -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Clean Start", -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Expiry", -1))
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Bridge", -1))
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Node", -1))
const _hoisted_125 = [
  _hoisted_112,
  _hoisted_113,
  _hoisted_114,
  _hoisted_115,
  _hoisted_116,
  _hoisted_117,
  _hoisted_118,
  _hoisted_119,
  _hoisted_120,
  _hoisted_121,
  _hoisted_122,
  _hoisted_123,
  _hoisted_124
]
const _hoisted_126 = { key: 0 }
const _hoisted_127 = ["colspan"]
const _hoisted_128 = {
  key: 1,
  class: "d-flex justify-content-center mt-3"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("select", {
                id: "hostSelect",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectedHost) = $event)),
                class: "form-select mb-2"
              }, [
                _hoisted_9,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableHosts, (host) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: host.host,
                    value: host
                  }, _toDisplayString(host.host), 9, _hoisted_10))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedHost]
              ])
            ]),
            (_ctx.selectedHost && _ctx.selectedHost.ca)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.downloadCACertificate && _ctx.downloadCACertificate(...args))),
                    class: "btn btn-secondary",
                    style: {"color":"#fff !important"}
                  }, _toDisplayString(_ctx.selectedHost.host) + "のCA証明書をインストール ", 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.connectToServer && _ctx.connectToServer(...args))),
              disabled: !_ctx.selectedHost || _ctx.isConnecting
            }, _toDisplayString(_ctx.isConnecting ? '接続中...' : '接続'), 9, _hoisted_12)
          ], 512), [
            [_vShow, _ctx.showNewConnection]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (_ctx.connections.length==0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, "接続がありません。"))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    (_ctx.connections.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          (_ctx.connections[0].activeSubscriptions.size > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.connections[0].activeSubscriptions, (topic) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: topic,
                                    class: "list-group-item d-flex justify-content-between align-items-center"
                                  }, [
                                    _createTextVNode(_toDisplayString(topic.replace("command/rex/dashboard/","")) + " ", 1),
                                    _createElementVNode("div", null, [
                                      (_ctx.connections[0].connected)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, "サーバに接続中"))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_24, "未接続"))
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_25, " 購読中のトピックはありません "))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.selectedPublishTopic) = $event)),
                              class: "form-select form-select-sm"
                            }, [
                              _hoisted_33,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publishableTopics, (role) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: role.topic,
                                  value: role.topic
                                }, _toDisplayString(role.topic.replace("command/device/","")), 9, _hoisted_34))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.selectedPublishTopic]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("button", {
                              onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.sendGetInfoMessage && _ctx.sendGetInfoMessage(...args))),
                              class: "btn btn-sm btn-primary",
                              disabled: !_ctx.selectedPublishTopic
                            }, " 接続 ", 8, _hoisted_36)
                          ]),
                          _hoisted_37,
                          _createElementVNode("div", _hoisted_38, [
                            (_ctx.relayStates.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relayStates, (relay) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: relay.id,
                                      class: "d-flex align-items-center mb-2"
                                    }, [
                                      _createElementVNode("span", _hoisted_40, _toDisplayString(relay.name) + ":", 1),
                                      _createElementVNode("div", _hoisted_41, [
                                        _withDirectives(_createElementVNode("input", {
                                          class: "form-check-input",
                                          type: "checkbox",
                                          id: 'switch-' + relay.id,
                                          "onUpdate:modelValue": $event => ((relay.state) = $event),
                                          onChange: $event => (_ctx.sendTurnOnMessage(relay)),
                                          disabled: !_ctx.selectedPublishTopic,
                                          style: {"cursor":"pointer"}
                                        }, null, 40, _hoisted_42), [
                                          [_vModelCheckbox, relay.state]
                                        ]),
                                        _createElementVNode("label", {
                                          class: "form-check-label",
                                          for: 'switch-' + relay.id
                                        }, _toDisplayString(relay.state ? 'ON' : 'OFF'), 9, _hoisted_43)
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _hoisted_44,
                          _withDirectives(_createElementVNode("div", _hoisted_45, [
                            _createTextVNode(_toDisplayString(_ctx.config) + " ", 1),
                            _hoisted_46,
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, [
                                _hoisted_49,
                                _createElementVNode("input", _hoisted_50, null, 512)
                              ]),
                              _createElementVNode("div", _hoisted_51, [
                                _hoisted_52,
                                _createElementVNode("input", _hoisted_53, null, 512)
                              ]),
                              _createElementVNode("div", _hoisted_54, [
                                _hoisted_55,
                                _createElementVNode("input", _hoisted_56, null, 512)
                              ]),
                              (_ctx.config.mail)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                    _hoisted_58,
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.config.mail.subject) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.config.mail.subject]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.config.mail)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    _hoisted_60,
                                    _withDirectives(_createElementVNode("textarea", {
                                      class: "form-control",
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.config.mail.body) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.config.mail.body]
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _hoisted_61,
                            (_ctx.config.twilio)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                  _createElementVNode("div", _hoisted_63, [
                                    _hoisted_64,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.twilio.phones, (phone, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: 'phone'+index,
                                        class: "input-group mb-1"
                                      }, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "tel",
                                          class: "form-control",
                                          "onUpdate:modelValue": $event => ((phone.Number) = $event),
                                          pattern: "[0-9\\-]+",
                                          placeholder: "電話番号"
                                        }, null, 8, _hoisted_65), [
                                          [_vModelText, phone.Number]
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "form-control",
                                          "onUpdate:modelValue": $event => ((phone.kana) = $event),
                                          pattern: "[ァ-ヶー　]*",
                                          placeholder: "カナ"
                                        }, null, 8, _hoisted_66), [
                                          [_vModelText, phone.kana]
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "form-control",
                                          "onUpdate:modelValue": $event => ((phone.name) = $event),
                                          placeholder: "名前"
                                        }, null, 8, _hoisted_67), [
                                          [_vModelText, phone.name]
                                        ]),
                                        _createElementVNode("button", {
                                          class: "btn btn-danger",
                                          onClick: $event => (_ctx.config.twilio.phones.splice(index, 1))
                                        }, "削除", 8, _hoisted_68)
                                      ]))
                                    }), 128)),
                                    _createElementVNode("button", {
                                      class: "btn btn-secondary btn-sm",
                                      onClick: _cache[7] || (_cache[7] = $event => (_ctx.config.twilio.phones.push({Number: '', kana: '', name: ''})))
                                    }, " 電話番号追加 ")
                                  ]),
                                  _createElementVNode("div", _hoisted_69, [
                                    _hoisted_70,
                                    _withDirectives(_createElementVNode("textarea", {
                                      class: "form-control",
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.config.twilio.body) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.config.twilio.body]
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_71,
                            (_ctx.config.iotHub)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                  _createElementVNode("div", _hoisted_73, [
                                    _hoisted_74,
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.config.iotHub.sensorName1) = $event)),
                                      required: ""
                                    }, null, 512), [
                                      [_vModelText, _ctx.config.iotHub.sensorName1]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_75, [
                                    _hoisted_76,
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.config.iotHub.sensorName2) = $event)),
                                      required: ""
                                    }, null, 512), [
                                      [_vModelText, _ctx.config.iotHub.sensorName2]
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("button", {
                                onClick: _cache[11] || (_cache[11] = (...args) => (_ctx.sendUpdateSettingMessage && _ctx.sendUpdateSettingMessage(...args))),
                                class: "btn btn-sm btn-primary",
                                disabled: !_ctx.selectedPublishTopic
                              }, " 更新 ", 8, _hoisted_78)
                            ])
                          ], 512), [
                            [_vShow, _ctx.config.mail]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        (_ctx.connections.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                              _hoisted_81,
                              _createElementVNode("div", _hoisted_82, [
                                _createElementVNode("div", _hoisted_83, [
                                  _createElementVNode("table", _hoisted_84, [
                                    _hoisted_85,
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.connections[0].receivedMessages, (msg, index) => {
                                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                          _createElementVNode("td", null, _toDisplayString(msg.topic), 1),
                                          _createElementVNode("td", null, _toDisplayString(msg.payload), 1),
                                          _createElementVNode("td", null, _toDisplayString(msg.timestamp), 1)
                                        ]))
                                      }), 128)),
                                      ( _ctx.connections[0].receivedMessages.length === 0)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_86, _hoisted_88))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.connections.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                            (_ctx.activeConnection?.host === _ctx.connections[0].host)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                  _createElementVNode("div", _hoisted_91, [
                                    _hoisted_92,
                                    _createElementVNode("div", _hoisted_93, [
                                      _createElementVNode("button", {
                                        class: _normalizeClass(["btn btn-sm", { 'btn-primary': _ctx.activeLogTab === 'command', 'btn-outline-primary': _ctx.activeLogTab !== 'command' }]),
                                        onClick: _cache[12] || (_cache[12] = $event => (_ctx.switchLogTab('command')))
                                      }, " コマンドログ ", 2),
                                      _createElementVNode("button", {
                                        class: _normalizeClass(["btn btn-sm", { 'btn-primary': _ctx.activeLogTab === 'event', 'btn-outline-primary': _ctx.activeLogTab !== 'event' }]),
                                        onClick: _cache[13] || (_cache[13] = $event => (_ctx.switchLogTab('event')))
                                      }, " イベントログ ", 2)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_94, [
                                    (_ctx.activeLogTab === 'command')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                          _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.selectedLogTopic) = $event)),
                                            class: "form-select form-select-sm",
                                            onChange: _cache[15] || (_cache[15] = (...args) => (_ctx.onLogTopicChange && _ctx.onLogTopicChange(...args)))
                                          }, [
                                            _hoisted_96,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLogTopics, (topic) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: topic,
                                                value: topic
                                              }, _toDisplayString(topic), 9, _hoisted_97))
                                            }), 128))
                                          ], 544), [
                                            [_vModelSelect, _ctx.selectedLogTopic]
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_98, [
                                      _createElementVNode("table", _hoisted_99, [
                                        _createElementVNode("thead", null, [
                                          (_ctx.activeLogTab === 'command')
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_100, _hoisted_110))
                                            : (_openBlock(), _createElementBlock("tr", _hoisted_111, _hoisted_125))
                                        ]),
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs, (log, index) => {
                                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                              (_ctx.activeLogTab === 'command')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createElementVNode("td", null, _toDisplayString(_ctx.formatTimestamp(log.publish_received_at)), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.topic), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.payload_command), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.payload_body !== 'undefined' ? log.payload_body : '-'), 1),
                                                    _createElementVNode("td", null, _toDisplayString(_ctx.formatTimestamp(log.payload_datetime)), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.clientid), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.username), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.qos), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.node), 1)
                                                  ], 64))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createElementVNode("td", null, _toDisplayString(_ctx.formatTimestamp(log.timestamp)), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.event), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.clientid), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.username), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.mountpoint !== 'undefined' ? log.mountpoint : '-'), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.peername !== 'undefined' ? log.peername : '-'), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.proto_name !== 'undefined' ? log.proto_name : '-'), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.proto_ver !== 'undefined' ? log.proto_ver : '-'), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.keepalive !== 'undefined' ? log.keepalive : '-'), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.clean_start !== 'undefined' ? log.clean_start : '-'), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.expiry_interval !== 'undefined' ? log.expiry_interval : '-'), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.is_bridge !== 'undefined' ? log.is_bridge : '-'), 1),
                                                    _createElementVNode("td", null, _toDisplayString(log.node), 1)
                                                  ], 64))
                                            ]))
                                          }), 128)),
                                          (_ctx.logs.length === 0)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_126, [
                                                _createElementVNode("td", {
                                                  colspan: _ctx.activeLogTab === 'command' ? 9 : 13,
                                                  class: "text-center"
                                                }, " ログはありません ", 8, _hoisted_127)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]),
                                    (_ctx.continuationToken)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                          _createElementVNode("button", {
                                            class: "btn btn-sm btn-primary",
                                            onClick: _cache[16] || (_cache[16] = (...args) => (_ctx.loadMoreLogs && _ctx.loadMoreLogs(...args)))
                                          }, " さらに読み込む ")
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 512), [
                  [_vShow, _ctx.connections.length && _ctx.connections[0].connected]
                ])
              ])
            ], 512), [
              [_vShow, _ctx.connections.length]
            ])
          ])
        ])
      ])
    ])
  ]))
}